import React, { useState } from 'react'
import { Dialog, DialogContent, IconButton, Tooltip } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import RtoRiskCard from './detail/RtoRiskCard'
import { getMerchant } from '../../helpers/ReduxHelpers'
import { rtoBand3 } from './rtoBand'

/**
 * Compact NETRA RTO-risk pill for merchant list views. Shows the risk score
 * (0–100) in a band-coloured pill labelled by the merchant 3-band
 * (High/Medium/Low/New buyer); clickable to open the full RtoRiskCard.
 * Shown by default; hidden only when the merchant is explicitly opted out
 * (showNetraScoreInMerchantPanel === false). Renders nothing when unscored.
 */
const RtoRiskBadge = ({ netra, orderId, scorePath, scoredStageNote }) => {
  const [open, setOpen] = useState(false)

  // Shown by default; hidden only when the merchant is explicitly opted out.
  if (getMerchant()?.showNetraScoreInMerchantPanel === false) return null
  if (!netra || netra.score === null || netra.score === undefined) return null
  const score = Math.round(Number(netra.score))
  if (Number.isNaN(score)) return null
  const b3 = rtoBand3(netra.band)
  const color = b3.hex
  const clickable = Boolean(orderId)

  const handleOpen = (e) => {
    if (!clickable) return
    e.stopPropagation()
    setOpen(true)
  }
  const handleClose = (e) => {
    e?.stopPropagation?.()
    setOpen(false)
  }

  return (
    <>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <Tooltip title={`RTO risk: ${b3.label} (${score}/100)${clickable ? ' · click for details' : ''}`} arrow>
        <span
          role={clickable ? 'button' : undefined}
          tabIndex={clickable ? 0 : undefined}
          onClick={handleOpen}
          onKeyDown={(e) => {
            if (clickable && (e.key === 'Enter' || e.key === ' ')) handleOpen(e)
          }}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 30,
            height: 22,
            padding: '0 8px',
            borderRadius: 11,
            background: color,
            color: '#fff',
            fontSize: 12,
            fontWeight: 700,
            lineHeight: '22px',
            letterSpacing: 0.2,
            cursor: clickable ? 'pointer' : 'default',
          }}
        >
          <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 0.4, opacity: 0.9, marginRight: 5 }}>RTO</span>
          {score}
        </span>
      </Tooltip>
        <span style={{ fontSize: 12, fontWeight: 600, color: '#454F5B', whiteSpace: 'nowrap' }}>{b3.label}</span>
      </span>

      {clickable && (
        <Dialog open={open} onClose={handleClose} maxWidth='xs' fullWidth onClick={(e) => e.stopPropagation()}>
          <IconButton onClick={handleClose} size='small' sx={{ position: 'absolute', right: 8, top: 8, zIndex: 1 }}>
            <CloseIcon fontSize='small' />
          </IconButton>
          <DialogContent sx={{ p: 2 }}>
            {open && <RtoRiskCard netra={netra} orderId={orderId} scorePath={scorePath} scoredStageNote={scoredStageNote} />}
          </DialogContent>
        </Dialog>
      )}
    </>
  )
}

export default RtoRiskBadge
